module.exports = __webpack_public_path__ + "static/media/5.24_preview.11a56113.png";